<div id="edit-menus">
  <button class="btn-floating btn-end" [hidden]="!clickDrawing" #crossButton title="End" (click)="whiteboard.container.tools.drawTool.stopDrawing()">
    <i class="fa fa-times"></i>
  </button>

  <button class="btn-floating btn-edit" [hidden]="!showEditButton" #editButton title="Edit" (click)="edit()">
    <i class="fa fa-pencil"></i>
  </button>

  <div class="btn-group btn-group-toggle btn-floating"
       id="edit-btn-resize-mode"
       #resizeModeButton
       data-toggle="buttons"
       [hidden]="!showResizeModeButton">
    <label class="btn"
           [class.active]="resizeMode === ResizeMode.WRAP"
           (click)="setResizeMode(ResizeMode.WRAP)">
      <img
        title="Wrap Mode"
        class="no-drag btn-floating-icon"
        src="assets/img/whiteboard/wrap-content.svg">
    </label>
    <label class="btn"
           [class.active]="resizeMode === ResizeMode.STRETCH"
           (click)="setResizeMode(ResizeMode.STRETCH)">
      <img
        title="Stretch Mode"
        class="no-drag btn-floating-icon"
        src="assets/img/whiteboard/stretch.svg">
    </label>
  </div>

  <div class="menu-floating edit-table-menu" #editTableMenu [hidden]="!canEditTable" style="width: 130px; margin: 3px; padding: 3px">
    <label style="float: left">Columns
      <input type="number" class="form-control whiteboard-btn" min="1" max="20" style="width: 50px"
             (keydown)="$event.code !== KeyCode.ARR_UP && $event.code !== KeyCode.ARR_DOWN && $event.preventDefault()"
             (change)="changeCols()"
             [(ngModel)]="activeTable.cols">
    </label>

    <label style="float: right">Rows
      <input type="number" class="form-control whiteboard-btn" min="1" max="20" style="width: 50px"
             (keydown)="$event.code !== KeyCode.ARR_UP && $event.code !== KeyCode.ARR_DOWN && $event.preventDefault()"
             (change)="changeRows()"
             [(ngModel)]="activeTable.rows">
    </label>
  </div>

  <div class="menu-floating number-line-edit-menu" #numberLineEditMenu [hidden]="!canEditNumberLine">
    <span class="header">X Axis:</span>
    <br>
    <label>Label:<input [(ngModel)]="editNumberLineMenuFields.xAxis.label"/></label>
    <label>Min:<input type="number" [(ngModel)]="editNumberLineMenuFields.xAxis.min"/></label>
    <label>Step:<input type="number" [(ngModel)]="editNumberLineMenuFields.xAxis.step" (input)="onInputChange($event)"/></label>
    <br>
    <label>Number of steps:<input type="number" [(ngModel)]="editNumberLineMenuFields.xAxis.numberOfSteps" (input)="onInputChange($event)" style="margin-left: 17px"/></label>
    <br>
    <label>Lines Per Step:<input type="number" [(ngModel)]="editNumberLineMenuFields.xAxis.linesPerStep" (input)="onInputChange($event)" style="margin-left: 33px"/></label>
    <br>

    <span class="header">Numbers: </span>
    <input type="checkbox" [(ngModel)]="editNumberLineMenuFields.showNumbers">
    <br>
    <span>Size: </span>
    <select [(ngModel)]="editNumberLineMenuFields.numberSize">
      <option *ngFor="let size of numberSizes" [ngValue]="size">
        {{size}}
      </option>
    </select>

    <button class="btn whiteboard-btn w-100 mt-3" (click)="setNumberLineProperties()">OK</button>
  </div>
  <div class="menu-floating edit-coordinate-plane-menu" #editCoordinatePlaneMenu [hidden]="!canEditCoordinatePlane">
    <span class="header">X Axis:</span>
    <br>
    <label>Label:<input [(ngModel)]="editCoordinatePlaneMenuFields.xAxis.label"/></label>
    <label>Min:<input type="number" [(ngModel)]="editCoordinatePlaneMenuFields.xAxis.min"/></label>
    <label>Step:<input type="number" [(ngModel)]="editCoordinatePlaneMenuFields.xAxis.step" (input)="onInputChange($event)"/></label>
    <br>
    <label>Number of steps:<input type="number" [(ngModel)]="editCoordinatePlaneMenuFields.xAxis.numberOfSteps" (input)="onInputChange($event)" style="margin-left: 17px"/></label>
    <br>
    <label>Lines Per Step:<input type="number" [(ngModel)]="editCoordinatePlaneMenuFields.xAxis.linesPerStep" (input)="onInputChange($event)" style="margin-left: 33px"/></label>
    <br>

    <span class="header">Y Axis:</span>
    <br>
    <label>Label:<input [(ngModel)]="editCoordinatePlaneMenuFields.yAxis.label"/></label>
    <label>Min:<input type="number" [(ngModel)]="editCoordinatePlaneMenuFields.yAxis.min"/></label>
    <label>Step:<input type="number" [(ngModel)]="editCoordinatePlaneMenuFields.yAxis.step" (input)="onInputChange($event)"/></label>
    <br>
    <label>Number of steps:<input type="number" [(ngModel)]="editCoordinatePlaneMenuFields.yAxis.numberOfSteps" (input)="onInputChange($event)" style="margin-left: 17px"/></label>
    <br>
    <label>Lines Per Step:<input type="number" [(ngModel)]="editCoordinatePlaneMenuFields.yAxis.linesPerStep" (input)="onInputChange($event)" style="margin-left: 33px"/></label>
    <br>

    <span class="header">Grid:</span>
    <input type="checkbox" [(ngModel)]="editCoordinatePlaneMenuFields.grid.show"/>
    <br>
    <label>By X:<input type="number" [(ngModel)]="editCoordinatePlaneMenuFields.grid.byX" (input)="onInputChange($event)"/></label>
    <label>By Y:<input type="number" [(ngModel)]="editCoordinatePlaneMenuFields.grid.byY" (input)="onInputChange($event)"/></label>
    <br>

    <span class="header">Numbers: </span>
    <input type="checkbox" [(ngModel)]="editCoordinatePlaneMenuFields.showNumbers">
    <br>
    <span>Size: </span>
    <select [(ngModel)]="editCoordinatePlaneMenuFields.numberSize">
      <option *ngFor="let size of numberSizes" [ngValue]="size">
        {{size}}
      </option>
    </select>
    <br>
    <span class="header">Border: </span>
    <input type="checkbox" [(ngModel)]="editCoordinatePlaneMenuFields.showBorder">

    <button class="btn whiteboard-btn w-100 mt-3" (click)="setCoordinatePlaneProperties()">OK</button>
  </div>
</div>
